import React from 'react';
import AdvertisementReservationExpiredWrapper from 'components/AdvertisementReservationExpiredWrapper';

export default function AdvertisementReservationExpiredContainer() {
  return <AdvertisementReservationExpiredWrapper />;
}
